import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { setA11yContent } from "../../NavigationHelper/actions";
import { fetchPageContent } from "../../DownloadAndDelete/actions";
import { ENDPOINTS } from "utils/endpoints";
import { media } from "utils/style";
import { checkNestedObject } from "utils/checkNestedObject";
import CommonContainer from "common-components/Container";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import Button from "common-components/Buttons";

class FamilyAppDownloadInformation extends Component {
  state = {
    loading: true
  };

  componentDidMount() {
    this.props.fetchPageContent(ENDPOINTS.FETCH_CVA_DOWNLOAD_PAGES).then(() => {
      this.setState({ loading: false });
      if (checkNestedObject(this.props.pageContent, "sc_pagetitle")){
        this.props.setA11yContent("Download information", this.props.pageContent.sc_pagetitle);
      }
    });
  }

  render() {
    if (this.props.loading || this.state.loading) {
      return <RectangleLoader style={{ padding: "0 16px" }} />;
    }
    const { pageContent } = this.props;

    return (
      <Container>
        <Header>{pageContent.section_title}</Header>
        <Div>
          {convertStringToElements(pageContent.section_description)}
          <div style={{ margin: "46px 0" }}>
            <Button
              background={pageContent.buttons[0].type}
              role="link"
              onClick={() =>
                this.props.history.replace({
                  pathname: "/privacy/secure/multifactor-authentication-primer",
                  state: { confirmAuth: true, nextRoute: "/privacy/secure/request-download" }
                })
              }
            >
              {pageContent.buttons[0].text}
            </Button>
          </div>
        </Div>
      </Container>
    );
  }
}

FamilyAppDownloadInformation.propTypes = {
  fetchPageContent: PropTypes.func.isRequired,
  setA11yContent: PropTypes.func.isRequired,
  pageContent: PropTypes.object,
  loading: PropTypes.bool
};

const mapStateToProps = ({ pageContent, loadingAndErrorState }) => ({
  pageContent: pageContent.download_information,
  loading: loadingAndErrorState.loading
});

export default connect(
  mapStateToProps,
  { fetchPageContent, setA11yContent }
)(FamilyAppDownloadInformation);

const Div = styled.div`
  max-width: 598px;

  p {
    padding: 10px 0;
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 16px;
   font-style: normal;
   font-weight: 400;
   line-height: 20px; 
   letter-spacing: 0.5px;
  }

  p:first-of-type {
    font-size: 24px;
    color:#6F7171;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
  }

  ${media.mobile`
    p:first-of-type {
    color:#000000;
    font-size: 16px;
    font-style: normal;
   font-weight: 400;
   line-height: 20px; /* 125% */
   letter-spacing: 0.5px
    }

    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
    letter-spacing: 0.5px;
  `}
`;

const Header = styled.h1`
  max-width: 598px;
  font-size: 48px;
  line-height: 48px;
  margin-bottom: 6px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-weight: 300;

${media.mobile`
  font-size: 32px;	
  line-height: 36px;
  font-weight: 300;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
`}
`;

const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 64px 20px ;
  ${media.mobile`
    margin: 0;
    padding: 32px 16px ;
  `}
`;